import { Map } from 'immutable'
import React, { Component } from 'react'
import { VideoPlayer } from '../common/videoPlayer'

export function getMaterialType(material) {
  if (material.getIn(['file', 'meta', 'type'], '').startsWith('video')) return 'video'

  if (material.getIn(['file', 'meta', 'type'], '').startsWith('image')) return 'image'

  if (material.get('type') === 'article') return 'article'

  return false
}

export function Video({ material }) {
  const file = material.get('file')
  if (!Map.isMap(file)) return <div className="message message--error">Error when loading video</div>

  // Use hls version if exists
  const src = file.getIn(['meta', 'versions', 'hls'], file.get('url'))
  const poster = file.getIn(['meta', 'thumbnail'])

  return (
    <div className="material-preview-item material-preview-item--video">
      <VideoPlayer src={src} poster={poster} />
    </div>
  )
}

export function Image({ material }) {
  return (
    <div className="material-preview-item material-preview-item--image">
      <img src={material.getIn(['file', 'url'])} />
    </div>
  )
}

export function Article({ material }) {
  return (
    <div className="material-preview-item material-preview-item--article">
      <div className="material-preview-article">
        <div
          className="material-preview-article-content"
          dangerouslySetInnerHTML={{ __html: material.get('content') }}
        />
      </div>
    </div>
  )
}

function CommentForm({ comment, onChange, t }) {
  return (
    <div className="approve-material-form">
      <textarea
        name="comment-notes"
        className="comment-notes"
        placeholder={t('approve.material.commentPlaceholder')}
        value={comment}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

export default function MaterialPreview({ group, groupId, comments, approves, onCommentChange, t }) {
  let approved = approves.get(groupId)

  return (
    <div className="approve-preview-list">
      {group.map(material => {
        let type = getMaterialType(material)

        let comment = comments.get(material.get('id'), '')

        return (
          <div className="approve-material" key={material.get('id')}>
            <div className="approve-material-preview">
              {type === 'video' ? (
                <Video material={material} />
              ) : type === 'image' ? (
                <Image material={material} />
              ) : type === 'article' ? (
                <Article material={material} />
              ) : (
                <div className="approve-material-preview-notfound">Materiaalia ei löytynyt.</div>
              )}
            </div>
            {approved === false ? (
              <CommentForm comment={comment} onChange={value => onCommentChange(material.get('id'), value)} t={t} />
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
